import React from 'react';

const CInput = ({
  defaultValue,
  onChange,
  name,
  placeholder,
  label,
  autofocus,
  error,
  ...rest
}) => {
  return (
    <div className="form-group">
      <div className="form-label-group">
        <input
          {...rest}
          defaultValue={defaultValue}
          onChange={onChange}
          name={name}
          id={name}
          className="form-control"
          placeholder={placeholder}
          autoFocus={autofocus}
        />
        <label htmlFor={name}>{label}</label>
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    </div>
  );
};

export default CInput;
